import { ref, computed } from 'vue';

export default (isFocused = false) => {
  const focused = ref(isFocused);
  const classes = computed(() => ({
    'c-input-focus': focused.value,
  }));
  return { focused, classes };
};
